// Coluna direita: legenda do âmbar, lista de trechos incertos e a nota de revisão.
// SEM player de áudio — o áudio é apagado após o STT (Regra 6), não há o que tocar.

import type { CSSProperties } from 'react';

import { cor, fonte } from '../../styles/tokens';
import type { Soap } from '../../api/types';
import { NotaRevisao } from './NotaRevisao';
import { TrechosIncertos } from './TrechosIncertos';

const coluna: CSSProperties = {
  padding: '18px 20px',
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
  overflow: 'hidden',
};

const rotulo: CSSProperties = {
  fontFamily: fonte.mono,
  fontSize: 10,
  letterSpacing: '.14em',
  color: cor.muted,
  marginBottom: 8,
};

export function PainelLateral({ soap }: { soap: Soap }): JSX.Element {
  return (
    <div style={coluna}>
      <div>
        <div style={rotulo}>O QUE O ÂMBAR SIGNIFICA</div>
        <div style={{ fontSize: 12.5, lineHeight: 1.5, color: cor.muted }}>
          Trecho que a transcrição não resolveu com segurança. Confira no áudio ou com o paciente{' '}
          <b style={{ color: cor.ambarTexto }}>antes de copiar</b>. Nenhum outro elemento usa esta
          cor.
        </div>
      </div>

      <TrechosIncertos soap={soap} />

      <NotaRevisao />
    </div>
  );
}
